export default __webpack_public_path__ + "static/media/revit-file.ed135098.svg";